import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import LandingPage from "@/pages/LandingPage";
import SocialsPage from "@/pages/SocialsPage";
import GalleryPage from "@/pages/GalleryPage";
import InfoDetailPage from "@/pages/InfoDetailPage";
import InspirationsPage from "@/pages/InspirationsPage";
import NoticesPage from "@/pages/NoticesPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import PortalPage from "@/pages/PortalPage";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <div className="grain-overlay" aria-hidden="true" />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/socials" element={<SocialsPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/info/:id" element={<InfoDetailPage />} />
          <Route path="/inspirations" element={<InspirationsPage />} />
          <Route path="/notices" element={<NoticesPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/portal" element={<PortalPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
